<template>
    <div class="page white_bg">

        <header class="pageHeader detailPageHeader white_bg bottomBorder101010" style="line-height: 46px;">
            <div class="flexLayout paddingH16">
                <div style="width: 16%">
                    <span class="icon leftAngleBracketIcon floatL" style="margin-top: 12px;" @click="back();"></span>
                </div>
                <div class="flexItem alignCenter font18r primaryTextColor bold hiddenOverflow"
                     style="height: 46px; ">
                    {{title}}
                </div>
                <div class="font14r alignRight" style="width: 16%">
                    <router-link class="block" :to="{name : 'search'}" style="margin-top: 3px;">
                        <i class="icon searchIcon" style="width: 18px; height: 19px; margin-top: 3px;"></i>
                    </router-link>
                </div>
            </div>
        </header>

        <div class="body">
            <div class="generalPagePaddingH">
                <div class="formRow">
                    <div class="columnName">字段1</div>
                    <div class="columnValue">
                        <input type="text" class="inputbox block" placeholder="请输入名称"/>
                    </div>
                </div>
                <div class="marginT16 font10r red">
                    *填写园区信息有助于园长申请，申请园长可查看简历的详细内容，更好的招聘更多优秀的幼师群体
                </div>
            </div>
        </div><!-- end .body -->

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

const config = {
    name : 'pageName',
    title : '页面标题',
    description : '',
    apiConfig : {
        get : {
            url : '',
            dataColumnMapping : {
                // userName : 'name'
            }
        }
    }
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : {  },
    data () {
        return {
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,
            formData : {}
        }
    }
}
</script>

<style lang="scss" scoped>
.formRow {
    .columnName {
        color: #5B616C;
    }
    .columnValue {
        .inputbox {
            display: block;
            width: 100%;
            font-size: 16px;
            height: 27px;
            line-height: 27px;
            border: none;
            background: transparent;
            color: hsla(0, 0%, 20%, 1);
            outline: none;
        }
        .inputbox::placeholder,
        .inputbox::-webkit-input-placeholder,
        .inputbox::-moz-placeholder,
        .inputbox::-ms-input-placeholder {
            color: hsla(220, 27%, 78%, 1);
        }
    }
}
</style>
